"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columns = exports.colStart = exports.colEnd = void 0;
require("./grid.css");
/**
 * DO NOT MODIFY
 * Generated from scripts/codegen/main.ts
 */

const columns = {
  'columns-1': "cds-columns-1-cim32y6",
  'columns-2': "cds-columns-2-c1qxhbhb",
  'columns-3': "cds-columns-3-c1qe1ekz",
  'columns-4': "cds-columns-4-c6k037l",
  'columns-5': "cds-columns-5-c1qwe4l3",
  'columns-6': "cds-columns-6-c1y7a5it",
  'columns-7': "cds-columns-7-c445aqv",
  'columns-8': "cds-columns-8-c4w7trq",
  'columns-9': "cds-columns-9-c1352ulv",
  'columns-10': "cds-columns-10-c15lau3k",
  'columns-11': "cds-columns-11-cm6e39x",
  'columns-12': "cds-columns-12-crkct4j"
};
exports.columns = columns;
const colStart = {
  'colStart-1': "cds-colStart-1-c10q2jgm",
  'colStart-2': "cds-colStart-2-c1yqga2t",
  'colStart-3': "cds-colStart-3-c1xcxmlu",
  'colStart-4': "cds-colStart-4-c9t0c3y",
  'colStart-5': "cds-colStart-5-cq01pv3",
  'colStart-6': "cds-colStart-6-c1loty9j",
  'colStart-7': "cds-colStart-7-c1rkqzzm",
  'colStart-8': "cds-colStart-8-c3hwj9d",
  'colStart-9': "cds-colStart-9-cu6a1by",
  'colStart-10': "cds-colStart-10-ctwcx44",
  'colStart-11': "cds-colStart-11-c1v09bvv",
  'colStart-12': "cds-colStart-12-c1829r4d",
  'colStart-auto': "cds-colStart-auto-cd8bzx9"
};
exports.colStart = colStart;
const colEnd = {
  'colEnd-1': "cds-colEnd-1-c10kb8il",
  'colEnd-2': "cds-colEnd-2-cpg8nwf",
  'colEnd-3': "cds-colEnd-3-c81eipy",
  'colEnd-4': "cds-colEnd-4-cxoel6h",
  'colEnd-5': "cds-colEnd-5-c1iddjqs",
  'colEnd-6': "cds-colEnd-6-c1n791um",
  'colEnd-7': "cds-colEnd-7-ckzzwm8",
  'colEnd-8': "cds-colEnd-8-cdert16",
  'colEnd-9': "cds-colEnd-9-c1t4j4u3",
  'colEnd-10': "cds-colEnd-10-c11ewykd",
  'colEnd-11': "cds-colEnd-11-c1jjjnbx",
  'colEnd-12': "cds-colEnd-12-c2lk2tr",
  'colEnd-13': "cds-colEnd-13-c15hs0tc",
  'colEnd-auto': "cds-colEnd-auto-c10140q0",
  'colEnd--1': "cds-colEnd--1-ck8kp7d"
};
exports.colEnd = colEnd;